var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89844 6.35937H14.1016V0.5H5.89844V6.35937ZM7.07031 5.1875V1.67187H12.9297V5.1875H7.07031Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5156 2.84375H6.48438V4.01562H13.5156V2.84375Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55469 20.5H16.4453V15.2265C16.4453 13.6085 15.1336 12.2969 13.5156 12.2969H11.7578V11.9005C13.0099 11.2963 13.9018 10.0385 14.072 8.61324C14.7701 8.38047 15.2734 7.72168 15.2734 6.9453C15.2734 5.97447 14.4865 5.18749 13.5156 5.18749V6.35936C13.8392 6.35936 14.1016 6.62168 14.1016 6.9453C14.1016 7.26892 13.8392 7.53124 13.5156 7.53124H12.9297V8.11718C12.9297 9.40689 12.1011 10.561 10.9766 10.9584L10.5859 11.0965V13.4687H13.5156C14.4864 13.4687 15.2734 14.2557 15.2734 15.2265V19.3281H4.72656V15.2265C4.72656 14.2557 5.51357 13.4687 6.48438 13.4687H9.41406V11.0965L9.02338 10.9584C7.89887 10.561 7.07031 9.40689 7.07031 8.11718V7.53124H6.48438C6.16075 7.53124 5.89844 7.26892 5.89844 6.9453C5.89844 6.62168 6.16075 6.35936 6.48438 6.35936V5.18749C5.51354 5.18749 4.72656 5.97447 4.72656 6.9453C4.72656 7.72168 5.22985 8.38047 5.92798 8.61324C6.0982 10.0385 6.99009 11.2963 8.24219 11.9005V12.2969H6.48438C4.86636 12.2969 3.55469 13.6085 3.55469 15.2265V20.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.5368L11.696 13.1448L10.6478 12.6208L10 13.9164L9.3522 12.6208L8.30405 13.1448L10 16.5368Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41406 15.2266V19.9141H10.5859V15.2266H9.41406Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07031 19.9141V12.8828H5.89844V19.9141H7.07031Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9297 12.8828V19.9141H14.1016V12.8828H12.9297Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.bfe51405fdabef320534b4f9ff5d844d.svg";
export { ForwardRef as ReactComponent };